/**
 * useAlertsUnread — shared poller for the count of un-reviewed alerts.
 *
 * Drives the Sidebar "Alerts" badge and the in-app notification toast. One
 * query key means TanStack Query dedupes the actual network request even when
 * several components subscribe.
 */
import { useQuery } from '@tanstack/react-query'
import { getAlertsUnreadCount } from '@/api/alerts'

export const ALERTS_UNREAD_KEY = ['alerts', 'unread-count'] as const

export function useAlertsUnread() {
  return useQuery({
    queryKey: ALERTS_UNREAD_KEY,
    queryFn: getAlertsUnreadCount,
    refetchInterval: 15_000,
    refetchOnWindowFocus: true,
    staleTime: 0,
  })
}
